/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserUpdateDTO interface.
 */
export function instanceOfUserUpdateDTO(value) {
    return true;
}
export function UserUpdateDTOFromJSON(json) {
    return UserUpdateDTOFromJSONTyped(json, false);
}
export function UserUpdateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'langKey': json['langKey'] == null ? undefined : json['langKey'],
        'onboarded': json['onboarded'] == null ? undefined : json['onboarded'],
    };
}
export function UserUpdateDTOToJSON(json) {
    return UserUpdateDTOToJSONTyped(json, false);
}
export function UserUpdateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'imageUrl': value['imageUrl'],
        'langKey': value['langKey'],
        'onboarded': value['onboarded'],
    };
}
